// 配置接口地址
export const api = {
  // 云台控制
  // ptcControl: '/vas/video/ptcControl.json',
  //新云台控制
  ptcControl: '/VIID/ptz/ctrl',
  ptcStart: '/VIID/ptz/start',
  ptcRelese: '/VIID/ptz/release',
  // 本地抓拍
  localSnap: '/vas/video/localSnap.json',
  // 一键抓拍
  localSnapList: '/vas/video/localSnapList.json',
  // 查询实时视频播放地址
  queryRealTimeVideoRtsp: '/vas/video/queryRealTimeVideoRtsp.json',
  // 查询录像列表
  queryVideoTimeList: '/vas/video/queryVideoTimeList.json',
  // 查询录像流
  queryPlayBackVideoRtsp: '/vas/video/queryPlayBackVideoRtsp.json',
  // 新建文件夹
  addFolder: '/vas/video/addFolder.json',
  // 修改文件夹
  updateFolder: '/vas/video/updateFolder.json',
  // 删除文件夹
  deleteFolder: '/vas/video/deleteFolder.json',
  // 查询文件夹列表
  queryFolderList: '/vas/video/queryFolderList.json',
  // 查询文件夹详情
  queryFolderDetail: '/vas/video/queryFolderDetail.json',
  // 设置监控点(新增/修改)
  setMonitorPoints: '/vas/video/setMonitorPoints.json',
  // 删除监控点
  deleteFolderOrMonitorPoint: '/vas/video/deleteFolderOrMonitorPoint.json',
  //新增视频轮巡:
  addVideoTour: '/vas/video/addVideoTour.json',

  //修改视频轮巡:
  updateVideoTour: '/vas/video/updateVideoTour.json',
  //新增视频轮巡场景:
  addVideoTourScene: '/vas/video/addVideoTourScene.json',
  //修改视频轮巡场景:
  updateVideoTourScene: '/vas/video/updateVideoTourScene.json',
  //查询轮巡及场景及摄像机:
  queryVideoTour: '/vas/video/queryVideoTour.json',
  //删除视频轮巡:
  deleteVideoTour: '/vas/video/deleteVideoTour.json',
  //删除视频轮巡场景:
  deleteVideoTourScene: '/vas/video/deleteVideoTourScene.json',


}